<template>
    <div class="fLogo">
        <h3><i class="icons-logoD"></i>{{ appName }}</h3>
        <p>邮箱：services@tipdm.com</p>
        <p>热线：400-684-0020</p>
        <p>地址：广州市黄埔区科学城凝彩路26号锦昊智谷2005房</p>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appName: ""
            }
        },
        created() {
            if(this.Cookies.get('APP_HEADER_NAME')){
                this.appName = decodeURI(this.Cookies.get('APP_HEADER_NAME'));
            }
        },
    }
</script>
